import { Route, Routes } from "react-router";
import RootLayout from "../components/RootLayout";
import Auth from "../pages/Auth";
import ProtectedRoute from "../components/ProtectedRoute";
import OrganizationSettings from "../pages/OrganizationSettings";
import Dev from "../pages/Dev";
import Welcome from "../pages/Welcome";
import DataEntry from "../pages/DataEntry";
import DataEdit from "../pages/DataEdit";
import BoatSettings from "../pages/BoatSettings";
import TourManagement from "../pages/TourManagement";
import Report from "../pages/Report";
import DateManagement from "../pages/DateManagement";
import Verify from "../pages/Verify";
import CreatePassword from "../pages/CreatePassword";
import ResetPassword from "../pages/ResetPassword";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/userVerify" element={<Verify />} />
      <Route path="/createPassword" element={<CreatePassword />} />
      <Route path="/resetPassword" element={<ResetPassword />} />
      <Route path="/" element={<Auth />} />
      <Route path="/" element={<RootLayout />}>
        <Route path="/dev" element={<Dev />} />
        <Route
          path="/welcome"
          element={
            <ProtectedRoute permission="view_welcome">
              <Welcome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/data_entry"
          element={
            <ProtectedRoute permission="view_data_entry">
              <DataEntry />
            </ProtectedRoute>
          }
        />
        <Route
          path="/data_edit"
          element={
            <ProtectedRoute permission="view_data_edit">
              <DataEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organization_settings"
          element={
            <ProtectedRoute permission="view_organization_settings">
              <OrganizationSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/boat_settings"
          element={
            <ProtectedRoute permission="view_boat_settings">
              <BoatSettings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tour_management"
          element={
            <ProtectedRoute permission="view_tour_management">
              <TourManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/date_management"
          element={
            <ProtectedRoute permission="view_date_management">
              <DateManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute permission="view_report">
              <Report />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}
